<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
<div class="profile:mb-fluid-lg">
  <div>
    <form [formGroup]="formGroup" [attr.aria-label]="translations.formAriaLabel" myprofileUiValidationTrack="email_editform">
      @if ((email && !email.isPorscheId) || !email) {
        <div>
          <profile-pds-p-input-email
            p-input-email
            id="email-input"
            [label]="translations.inputLabel"
            [state]="!!emailFormControlErrorMessage ? 'error' : 'none'"
            [message]="emailFormControlErrorMessage"
            data-protractor-id="emailInputField"
            [attr.data-has-error]="!!emailFormControlErrorMessage"
            [readOnly]="email && email.isVerified === true"
            name="email"
            formControlName="email"
            [placeholder]="translations.inputPlaceholder"
          >
          </profile-pds-p-input-email>
        </div>
      }
      @if (email && email.isVerified === true && email.isPorscheId === false) {
        <profile-pds-p-text class="profile:text-[14px] profile:mt-fluid-sm" p-text size="inherit" color="contrast-medium">
          <div [innerHTML]="translations.verifiedEmailDescription"></div>
        </profile-pds-p-text>
      }
      @if (email && email.isPorscheId && !email.isStandard) {
        <div
          class="profile:mb-fluid-md profile:min-w-60 profile:max-w-full profile:max-xs:min-w-[320px] profile:max-sm:not-last:me-static-lg profile:max-xs:first:mt-0 profile:mt-fluid-md profile:md:mt-0"
        >
          <div>
            <profile-pds-p-icon p-icon name="lock" aria-hidden="true"></profile-pds-p-icon>
            <profile-pds-p-text p-text size="inherit" class="profile:text-[14px] profile:inline-block" color="contrast-medium">{{
              translations.porscheIDLabel
            }}</profile-pds-p-text>
          </div>
          <profile-pds-p-text p-text size="inherit" class="profile:text-[20px]">
            <div [innerHTML]="email.email"></div>
          </profile-pds-p-text>
          <profile-pds-p-button-pure
            [attr.id]="'goToChangePorscheIdPage-editor-' + (email.emailId || 'new')"
            p-button-pure
            class="profile:py-static-sm"
            (click)="goToChangePorscheIdPage()"
            [myprofileUiTrack]="{
              clickElementType: 'link',
              clickElementId: 'email_address',
              clickElementName: 'goto_change_porsche_id_link',
            }"
            >{{ translations.changePorscheIDLinkLabel }}</profile-pds-p-button-pure
          >
        </div>
      }
      <profile-pds-p-checkbox
        data-protractor-id="checkbox-is-standard-email"
        p-checkbox
        class="profile:mt-fluid-md"
        [label]="translations.setAsPrimaryEmailAddressLabel"
        [hideLabel]="false"
        name="isStandard"
        formControlName="isStandard"
      >
      </profile-pds-p-checkbox>
      <div class="profile:flex profile:flex-col profile:gap-y-fluid-sm profile:sm:gap-x-fluid-sm profile:sm:flex-row profile:mt-fluid-md">
        <profile-pds-p-button
          [aria]="{ 'aria-label': translations.saveButtonA11y }"
          p-button
          variant="primary"
          (click)="submitForm(formGroup)"
          icon="check"
          [myprofileUiTrack]="{
            clickElementType: 'button',
            clickElementId: 'email_address',
            clickElementName: getSubmitButtonLabel() === translations.saveButtonLabel ? 'save' : 'save_and_verify',
          }"
        >
          {{ getSubmitButtonLabel() }}
        </profile-pds-p-button>
        <profile-pds-p-button
          [aria]="{ 'aria-label': translations.cancelButtonA11y }"
          p-button
          variant="secondary"
          (click)="cancel()"
          icon="close"
          [myprofileUiTrack]="{
            clickElementType: 'button',
            clickElementId: 'email_address',
            clickElementName: 'cancel',
          }"
        >
          {{ translations.cancelButtonLabel }}
        </profile-pds-p-button>
      </div>
    </form>
    @if (formGroup.get('isStandard')!.value === true && formGroup.get('isVerified')!.value === false) {
      <profile-pds-p-text p-text size="inherit" class="profile:text-[14px] profile:mt-fluid-sm">
        <div [innerHTML]="translations.isStandardInfoText"></div>
      </profile-pds-p-text>
    }
  </div>
</div>
